import React from "react";
import { TextField } from "@mui/material";

function EmailInput({ name, label, register, errors, validate }) {
  return (
    <TextField
      label={label}
      type="email"
      {...register(name, {
        required: `${label} is required`,
        pattern: {
          value:
            /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
          message: "Invalid email format",
        },
        validate: validate,
      })}
      error={errors[name] ? true : false}
      helperText={errors[name]?.message}
    />
  );
}

export default EmailInput;
